import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map, tap } from 'rxjs';

import { environment } from '../../../environments/environment';
import { showNotification } from '../components/app-notifications/app-notifications.component';
import { ClientConfiguration } from '../models/clientConfiguration';
import { ServiceResponse } from '../models/serviceResponse.model';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class UserService {
	private _baseUrl = environment.baseUrl + '/users';

	constructor(
		private http: HttpClient,
	) {
	}

	async getUsers() {
		const users$ = this.http
			.get<ServiceResponse<User[]>>(this._baseUrl)
			.pipe(tap(response => console.log({ getUsersResponse: response })))
			.pipe(map(response => response.result!));
		return await lastValueFrom(users$);
	}

	async getUser(userId: string) {
		const user$ = this.http
			.get<ServiceResponse<User>>(this._baseUrl + "/" + encodeURIComponent(userId))
			.pipe(tap(response => console.log({ getUserResponse: response })))
			.pipe(map(response => response.result!));
		return await lastValueFrom(user$);
	}

	async updateUser(userId: string, configuration: ClientConfiguration) {
		const users = [
			{
				id: userId,
				client: {
					configuration
				}
			}
		];
		const patchResult$ = this.http
			.patch<ServiceResponse<{}>>(this._baseUrl, users)
			.pipe(tap(response => console.log({ updateUserResponse: response })));
		const serviceResponse = await lastValueFrom(patchResult$);

		if (serviceResponse.isSuccess)
			showNotification('success', 'Success', 'User updated successfully', 5);
		else
			showNotification('error', 'Error', 'Failed to update user: ' + serviceResponse.messages);
	}
}
